import { call, fork, put, takeEvery } from 'redux-saga/effects';

import { Logger } from '@/services/errors/appLogger';
import {
    AllCampaignsLoaded,
    AllCampaignsLoadedError,
    AllChannelsLoaded,
    AllChannelsLoadedError,
    LocationCountryChannelLoadingError,
    LocationCountryChannelLoadingFinished,
    LocationCountryLoadingError,
    LocationCountryLoadingFinished,
    LocationWorldChannelLoadingError,
    LocationWorldChannelLoadingFinished,
    LocationWorldLoadingError,
    LocationWorldLoadingFinished,
} from '../store/activity/locations/actions';
import {
    getAllCampaigns,
    getAllChannels,
    getCountryChannelLocations,
    getCountryLocation,
    getWorldChannelLocation,
    loadLocationActivity,
} from '../services/ElasticApi';
import {
    LocationCountryChannelFetchStartAction,
    LocationCountryFetchStartAction,
    LocationWorldChannelFetchStartAction,
    LocationWorldFetchStartAction,
} from '../store/activity/locations/types';

function* fetchCampaignsList(): any {
    const params = {};

    try {
        const campaigns = yield call(getAllCampaigns, params);

        yield put(AllCampaignsLoaded(campaigns));
    } catch (e) {
        Logger.error(e);
        yield put(AllCampaignsLoadedError());
    }
}

function* fetchChannelsList(): any {
    const params = {};
    try {
        const channels = yield call(getAllChannels, params);
        yield put(AllChannelsLoaded(channels.data));
    } catch (e) {
        Logger.error(e);
        yield put(AllChannelsLoadedError());
    }
}

function* fetchLocationWorldActivity(action: LocationWorldFetchStartAction): any {
    const { payload } = action;
    const params = {
        from: payload.from,
        to: payload.to,
        limit: payload.limit,
        offset: payload.offset,
        onlyWithData: payload.onlyWithData,
    };

    try {
        const locationWorldActivity = yield call(loadLocationActivity, params);
        yield put(LocationWorldLoadingFinished(locationWorldActivity));
    } catch (e) {
        Logger.error(e);
        yield put(LocationWorldLoadingError());
    }
}

function* fetchLocationWorldChannelActivity(action: LocationWorldChannelFetchStartAction): any {
    const { payload } = action;
    const params = {
        name: payload.name,
        from: payload.from,
    };

    try {
        const data = yield call(getWorldChannelLocation, params);
        const locationWorldChannelActivity = data.LocationStats ? data.LocationStats : data;

        yield put(LocationWorldChannelLoadingFinished(locationWorldChannelActivity));
    } catch (e) {
        Logger.error(e);
        yield put(LocationWorldChannelLoadingError());
    }
}

function* fetchLocationCountryActivity(action: LocationCountryFetchStartAction): any {
    const { payload } = action;
    const params = {
        countryiso: payload.countryiso,
        from: payload.from,
        to: payload.to,
    };

    try {
        const locationCountryActivity = yield call(getCountryLocation, params);
        yield put(LocationCountryLoadingFinished(locationCountryActivity, params.countryiso));
    } catch (e) {
        Logger.error(e);
        yield put(LocationCountryLoadingError());
    }
}

function* fetchLocationCountryChannelActivity(action: LocationCountryChannelFetchStartAction): any {
    const { payload } = action;
    const params = {
        countryiso: payload.countryiso,
        name: payload.name,
        from: payload.from,
        to: payload.to,
    };

    try {
        const locationCountryChannelActivity = yield call(getCountryChannelLocations, params);
        yield put(LocationCountryChannelLoadingFinished(locationCountryChannelActivity, params.countryiso));
    } catch (e) {
        Logger.error(e);
        yield put(LocationCountryChannelLoadingError());
    }
}

function* watchFetchCampaignsList(): any {
    yield takeEvery('@@allcampaigns/FETCH_START', fetchCampaignsList);
}

function* watchFetchChannelsList(): any {
    yield takeEvery('@@allchannels/FETCH_START', fetchChannelsList);
}

function* watchFetchLocationWorldActivity(): any {
    yield takeEvery('@@locationworld/FETCH_START', fetchLocationWorldActivity);
}

function* watchFetchLocationWorldChannelActivity(): any {
    yield takeEvery('@@locationworldchannel/FETCH_START', fetchLocationWorldChannelActivity);
}

function* watchFetchLocationCountryActivity(): any {
    yield takeEvery('@@locationcountry/FETCH_START', fetchLocationCountryActivity);
}

function* watchFetchLocationCountryChannelActivity(): any {
    yield takeEvery('@@locationcountrychannel/FETCH_START', fetchLocationCountryChannelActivity);
}

const locationSagas = [
    fork(watchFetchCampaignsList),
    fork(watchFetchChannelsList),
    fork(watchFetchLocationWorldActivity),
    fork(watchFetchLocationWorldChannelActivity),
    fork(watchFetchLocationCountryActivity),
    fork(watchFetchLocationCountryChannelActivity),
];
export default locationSagas;
